import { QRCode, ShareButton } from "@indietabletop/appkit";
import { NonFormDialog } from "../FormDialog/FormDialog.tsx";
import { useGangContext } from "../GangPage/useGang.ts";
import { useEnsureShareId } from "../GangPrintPage/useEnsureShareId.tsx";
import { ReadonlyTextField } from "../forms/FormTextField.tsx";
import redditIcon from "./reddit.svg";
import { shareDialog } from "./style.css.ts";

function getShareLink(snapshotId: string) {
  return `${window.origin}/gangs/s/${snapshotId}`;
}

export function ShareGangDialog() {
  const { gang } = useGangContext();
  const result = useEnsureShareId(gang);

  const shareData = result
    .mapSuccess((snapshotId) => ({
      url: getShareLink(snapshotId),
      title: gang.name,
    }))
    .valueOrNull();

  const shareLink = result.unpack(
    (snapshotId) => getShareLink(snapshotId),
    (message) => message,
    () => `Loading...`,
  );

  const redditShareUrl = result
    .mapSuccess(
      (value) =>
        `https://reddit.com/r/indietabletopclub/submit?${new URLSearchParams({
          url: getShareLink(value),
          title: `Check out my Space Gits gang ${gang.name}.`,
          type: "LINK",
        })}`,
    )
    .valueOrNull();

  const urlResult = result.mapSuccess((snapshotId) => getShareLink(snapshotId));

  return (
    <NonFormDialog overline="City of Gnork" heading="Arrest Warrant">
      <div>
        <p className={shareDialog.info}>
          Share this version of {gang.name} with the world! If you make changes,
          you will need to generate a new link for others to see them.
        </p>

        <ReadonlyTextField label="Share URL" value={shareLink} />

        <div className={shareDialog.row}>
          <ShareButton
            className={shareDialog.button}
            shareData={shareData}
            copyLabel="Copy link"
            shareLabel="Share link"
          />

          <a
            className={shareDialog.redditButton}
            href={redditShareUrl ?? undefined}
            title="Share on Reddit"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              src={redditIcon}
              alt="Share on Reddit"
              style={{ maxInlineSize: "3rem", margin: "-0.9rem -1rem" }}
            />
          </a>
        </div>
      </div>

      <div className={shareDialog.inPersonSharing}>
        <div className={shareDialog.inPersonHeading}>Sharing in person?</div>
        <p>Let your chums scan this here QR code.</p>
      </div>

      <div
        style={{
          backgroundColor: "white",
          padding: "5rem 3rem",
        }}
      >
        <QRCode url={urlResult} className={shareDialog.qr} />
      </div>
    </NonFormDialog>
  );
}
